import { Alert } from 'antd'
import React from 'react'

/** Matches API default in `viewRefundStatsByRefundStartDate` when no `fromDate` is sent. */
export const REFUND_STATS_PROGRAM_START = '2024-07-25'

function formatDateLabel(value: string): string | null {
  if (value == null || value.trim() === '') {
    return null
  }
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) {
    return value.trim()
  }
  return d.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  })
}

export interface RefundStatsRangeAlertProps {
  fromDate: string
  toDate: string
}

/**
 * Visible notice: default reporting start (25 July 2024) and how KPI totals relate to the period
 * (Total Paid, refund requests, and Remaining to Request use the same date window).
 */
export function RefundStatsRangeAlert(props: RefundStatsRangeAlertProps): JSX.Element {
  const fromLabel = formatDateLabel(props.fromDate)
  const toLabel = formatDateLabel(props.toDate)

  const periodLine =
    fromLabel != null && toLabel != null
      ? `Selected period: ${fromLabel} – ${toLabel}.`
      : fromLabel != null
        ? `Selected start: ${fromLabel} (end: today).`
        : toLabel != null
          ? `End date only: through ${toLabel} (start defaults to ${REFUND_STATS_PROGRAM_START}).`
          : `Statistics use data from ${REFUND_STATS_PROGRAM_START} through today.`

  return (
    <Alert
      type="info"
      showIcon
      message="Refund statistics period"
      description={
        <div style={{ fontSize: 14, lineHeight: 1.5, fontWeight: 500 }}>
          {periodLine}
        </div>
      }
      style={{
        marginBottom: 12,
        padding: '14px 16px',
        borderRadius: 12
      }}
    />
  )
}
